// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".post-continer[data-v-7b0fb740] {\n  height: 100%;\n}\n.post-continer .van-list .top-warp[data-v-7b0fb740] {\n  width: 100%;\n  background: #fff;\n  overflow: hidden;\n}\n.post-continer .van-list .inner-warp[data-v-7b0fb740] {\n  background: #fff;\n  display: flex;\n  flex-flow: wrap;\n}\n.post-continer .van-list .inner-warp[data-v-7b0fb740] :nth-child(3n) {\n  border-right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
